import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import Link from "next/link";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";

export default function ReadyToApply({
  bgColor,
  link,
  path,
  title = "Submit Vacancies",
  button1Link = "/vacancies",
}) {
  const locale = useLocale();

  return (
    <div className={bgColor}>
      <div className="flex justify-between flex-col items-center sm:flex-row md:flex-row lg:flex-row w-full pb-8 pt-8 pl-16 pr-16">
        <span className="text-purple w-full text-center sm:text-start sm:w-[50%] text-base sm:text-[20px]/[30px]  md:text-[30px]/[40px] lg:text-[30px]/[40px]">
          <CustomSourceFlowText
            title="Ready to apply for a job that makes a difference? Let’s get started."
            path={`dynamic1.${path}.header1`}
            locale={locale}
          />
        </span>
        <div className="flex justify-center items-center gap-7 h-10 md:h-[54px] w-max mt-4 md:mt-0">
          <ExpandingButton
            url={button1Link}
            color="#1B0D34"
            bgColor="transparent"
            hoverBGColor="#1B0D34"
            hoverColor="white"
          >
            <CustomSourceFlowText
              title={title}
              path={`dynamic1-submit.${path}.readyapply`}
              locale={locale}
            />
          </ExpandingButton>
          {link && (
            <Link
              href={localizePath("/contact", locale)}
              color="purple"
              className="py-2 px-5 text-[#1B0D34] text-[20px] underline sm:text-xl text-center w-max"
            >
              <CustomSourceFlowText
                title="Contact Us"
                path={`dynamic1-contact.${path}.readyapply`}
                locale={locale}
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
